const { viewportSize } = window.BAO.Utils

window.BAO.Brands = {
  identifier: 'data-brands-el',
  currentTab: 'brands',
  get els () {
    const keys = new Set(
      getElements(`[${this.identifier}]`).map(
        element => element.dataset.brandsEl,
      ),
    )
    const array = [...keys].map(key => {
      return {
        [key]: {
          get selector () {
            return `[${window.BAO.Brands.identifier}="${key}"]`
          },
          get element () {
            return this.elements?.[0]
          },
          get elements () {
            return getElements(this.selector)
          },
          get exists () {
            return !!this.element
          },
        },
      }
    })
    return array.reduce((a, b) => Object.assign(a, b), {})
  },
  get sectionId () {
    return window.BAO.Brands.els.container.element
      .closest('.shopify-section')
      .getAttribute('id')
      .replace('shopify-section-', '')
  },
  showFavouriteBrands (context) {
    getElements(window.BAO.Brands.els?.['brand-item']?.selector, {
      context,
    })?.forEach(brandEl => {
      const activeFavouriteEl = getElement(
        '[is="favourites-heart"].wlt-Heart-active',
        { context: brandEl },
      )
      brandEl.setAttribute('aria-hidden', String(!activeFavouriteEl))
    })
  },
  hideEmptySections (context) {
    getElements(window.BAO.Brands.els?.section?.selector, {
      context,
    })?.forEach(sectionEl => {
      const visibleBrandEls = getElements(
        `${window.BAO.Brands.els?.['brand-item']?.selector}[aria-hidden="false"]`,
        { context: sectionEl },
      )
      sectionEl.setAttribute('aria-hidden', String(!visibleBrandEls?.length))

      if (sectionEl.hasAttribute('id')) {
        getElement(`[href='#${sectionEl.getAttribute('id')}']`)?.setAttribute(
          'data-item-count',
          String(visibleBrandEls.length),
        )
      }

      sectionEl.removeAttribute('data-last')
    })
  },
  togglePromoElements (isVisible) {
    Brands.els?.promo?.elements.forEach(promoEl => {
      promoEl.setAttribute('aria-hidden', String(!isVisible))
    })
  },
  visibleSectionEls (context) {
    return getElements(
      `${window.BAO.Brands.els?.section?.selector}[aria-hidden='false']`,
      { context },
    )
  },
  removePromoElements (context) {
    getElements(Brands.els.promo?.selector, {
      context,
    }).forEach(promoEl => promoEl.remove())
  },
  renderDrawerFavourites () {
    if (
      Brands.els?.['body-desktop']?.exists &&
      Brands.els?.['body-mobile']?.exists
    ) {
      Brands.els['body-mobile'].element.innerHTML =
        Brands.els?.['body-desktop'].element.innerHTML

      Brands.filterFavourites(Brands.els['body-mobile'].element)
      Brands.removePromoElements(Brands.els['body-mobile'].element)
    }
  },
  filterFavourites (context) {
    Brands.showFavouriteBrands(context)
    Brands.hideEmptySections(context)

    Brands.toggleNoFavouritesMessaging(
      !Brands.visibleSectionEls(context).length,
    )
  },
  toggleNoFavouritesMessaging (isVisible) {
    getElements(Brands.els['no-favourites']?.selector, {
      context: Brands.els['body-desktop'].element,
    })?.forEach(messageEl => {
      if (Brands.currentTab === 'favourites') {
        messageEl.setAttribute('aria-hidden', String(!isVisible))
      } else {
        messageEl.setAttribute('aria-hidden', 'true')
      }
    })

    getElements(Brands.els['no-favourites']?.selector, {
      context: Brands.els['body-mobile'].element,
    })?.forEach(messageEl => {
      messageEl.setAttribute('aria-hidden', String(!isVisible))
    })
  },
  showAll (context) {
    const brandEls = getElements(Brands.els?.['brand-item']?.selector, {
      context,
    })
    brandEls?.forEach(brandEl => {
      brandEl.setAttribute('aria-hidden', 'false')
    })

    const sectionEls = getElements(Brands.els?.section?.selector, {
      context,
    })
    sectionEls?.forEach(brandSectionEl => {
      brandSectionEl.setAttribute('aria-hidden', 'false')
    })
  },
  async renderFavourites (mobileOnly) {
    const desktopBodyEl = Brands.els?.['body-desktop']?.element
    const mobileBodyEl = Brands.els?.['body-mobile']?.element

    if (desktopBodyEl && mobileBodyEl) {
      Brands.els.container.element.setAttribute('aria-busy', true)

      const html = await fetchSingle(Brands.sectionId, window.location.pathname)

      if (html?.length) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
        const sectionEl = getElement(Brands.els?.['body-desktop']?.selector, {
          context: parsedHTML,
        })

        Brands.filterFavourites(sectionEl)

        if (!mobileOnly) {
          desktopBodyEl.innerHTML = sectionEl.innerHTML
        }
        mobileBodyEl.innerHTML = sectionEl.innerHTML

        Brands.removePromoElements(mobileBodyEl)

        Brands.els.container.element.setAttribute('aria-busy', false)
      }
    }
  },
  reset: () => {
    Brands.toggleNoFavouritesMessaging(false)
    window.BAO.Brands?.els?.section?.elements?.forEach(sectionEl => {
      sectionEl.setAttribute('aria-hidden', 'false')
    })
    window.BAO.Brands?.els?.['brand-item']?.elements?.forEach(brandEl => {
      brandEl.setAttribute('aria-hidden', 'false')
    })
  },
  resetTabs () {
    document.dispatchEvent(new CustomEvent('reset-tabs'))
  },
  resetCategories () {
    document.dispatchEvent(new CustomEvent('reset-categories'))
  },
  resetSearch () {
    document.dispatchEvent(new CustomEvent('reset-search'))
  },
}

const { Brands } = window.BAO
const { getElement, getElements, debounce, isTouchDevice } = window.BAO.Utils
const { fetchSingle } = window.BAO.sectionRenderer
export class BrandsTabs extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'toggle']
  }

  static get requiredExternalElements () {
    return ['drawer-trigger']
  }

  connectedCallback () {
    super.connectedCallback()

    Brands.renderDrawerFavourites()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick.bind(this))

    if (this.externalEls?.['drawer-trigger']?.exists) {
      this.listeners.add(
        this.externalEls['drawer-trigger'].element,
        'click',
        this.handleDrawerTriggerClick.bind(this),
      )
    }

    this.listeners.add(document, 'reset-tabs', this.handleReset.bind(this))

    this.listeners.add(
      document,
      'wishlist:favouritesUpdated',
      this.handleFavouritesUpdated.bind(this),
    )

    if (Brands.els?.['reset-tabs']?.exists) {
      Brands.els['reset-tabs'].elements.forEach(resetEl => {
        this.listeners.add(resetEl, 'click', () => {
          getElement('[data-brands-tabs-el="trigger"]').click()
          Brands.resetTabs()
        })
      })
    }
  }

  async handleFavouritesUpdated () {
    if (Brands.currentTab === 'favourites' && viewportSize() !== 'xs') {
      await Brands.renderFavourites()
    } else {
      Brands.renderDrawerFavourites()
    }
  }

  handleReset () {
    const brandsTrigger = Brands.els?.trigger?.elements?.find(
      triggerEl =>
        triggerEl.dataset.key === 'brands' &&
        triggerEl.getAttribute('aria-current') !== 'true',
    )
    if (!brandsTrigger) return
    Brands.els?.trigger?.elements?.forEach(triggerEl =>
      triggerEl.setAttribute('aria-current', triggerEl.dataset.key === 'brands'),
    )

    Brands.els?.toggle?.elements?.forEach(toggleEl => {
      toggleEl.setAttribute(
        'aria-hidden',
        String(toggleEl.dataset?.key !== brandsTrigger.dataset?.key),
      )
    })
  }

  handleClick (event) {
    const clickedTrigger = event.target.closest(this.els?.trigger?.selector)
    if (!clickedTrigger) return

    Brands.currentTab = clickedTrigger.dataset?.key

    Brands.togglePromoElements(Brands.currentTab !== 'favourites')

    this.els.trigger.elements.forEach(triggerEl => {
      const keyMatches = triggerEl.dataset?.key === clickedTrigger.dataset?.key
      triggerEl.setAttribute('aria-current', String(keyMatches))
      document.body.classList.toggle(
        `lyt-CurrentTab-${triggerEl.dataset?.key}`,
        keyMatches,
      )
    })

    this.els?.toggle?.elements?.forEach(toggleEl => {
      toggleEl.setAttribute(
        'aria-hidden',
        String(toggleEl.dataset?.key !== clickedTrigger.dataset?.key),
      )
    })

    Brands.reset()
    Brands.resetSearch()
    Brands.resetCategories()

    if (clickedTrigger.dataset?.key === 'favourites') {
      Brands.filterFavourites(Brands.els['body-desktop'].element)
    } else {
      Brands.showAll(Brands.els['body-desktop'].element)
    }
  }

  handleDrawerTriggerClick () {
    Brands.filterFavourites(Brands.els['body-mobile'].element)
  }
}

if (!customElements.get('brands-tabs')) {
  customElements.define('brands-tabs', BrandsTabs)
}

export class BrandsCategories extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger']
  }

  get bodyDesktopBrandItems () {
    return {
      elements: getElements(Brands.els['brand-item'].selector, {
        context: Brands.els['body-desktop'].element,
      }),
    }
  }

  setupListeners () {
    super.setupListeners()

    if (Brands.els?.['brand-item']?.exists && this.els?.trigger?.exists) {
      this.listeners.add(this, 'click', this.handleClick.bind(this))
    }

    if (Brands.els['brand-categories-mobile-trigger']?.exists) {
      this.listeners.add(
        Brands.els['brand-categories-mobile-trigger'].element,
        'click',
        () => {
          if (Brands.els['search-input']?.element?.value?.length) {
            Brands.reset()
            Brands.resetSearch()
            Brands.resetCategories()
          }
        },
      )
    }

    if (Brands.els?.['reset-categories']?.exists) {
      this.listeners.add(
        Brands.els['reset-categories'].element,
        'click',
        this.handleResetClick.bind(this),
      )
    }

    this.listeners.add(
      document,
      'reset-categories',
      this.handleReset.bind(this),
    )
  }

  handleReset () {
    Brands.els['brand-item']?.elements?.forEach(brandEl => {
      brandEl.setAttribute('data-brands-categories-match', 'unset')
      brandEl.setAttribute('aria-hidden', 'false')
    })

    this.els?.trigger?.elements?.forEach(triggerEl =>
      triggerEl.setAttribute('aria-checked', 'false'),
    )

    this.updateCountButton(this.bodyDesktopBrandItems.elements.length, 0)
  }

  handleClick (event) {
    const itemEls = Brands.els['brand-item'].elements
    const clickedTriggerEl = event.target.closest(this.els.trigger.selector)
    if (!itemEls.length || !clickedTriggerEl) return

    clickedTriggerEl.setAttribute(
      'aria-checked',
      String(clickedTriggerEl.getAttribute('aria-checked') !== 'true'),
    )

    const activeCategories = this.activeTriggerEls.map(
      triggerEl => triggerEl.dataset.brandsCategoriesCategory,
    )

    const activeBrandEls = itemEls.filter(itemEl => {
      const isMatch = activeCategories.includes(
        itemEl.dataset.brandsCategoriesCategory,
      )
      const matchValue = activeCategories.length ? isMatch : 'unset'
      itemEl.setAttribute('data-brands-categories-match', String(matchValue))
      return isMatch
    })

    const brandCount =
      activeCategories.length > 0 && activeBrandEls.length > 0
        ? getElements('[data-brands-categories-match="true"]', {
          context: Brands.els['body-desktop'].element,
        }).length
        : this.bodyDesktopBrandItems.elements.length
    this.updateCountButton(brandCount, activeCategories.length)
  }

  updateCountButton (brandCount, activeCategoryCount) {
    if (Brands.els?.count?.exists) {
      const buttonText = Brands.els.count.element.dataset?.brandsCategoriesTranslationShowBrands?.replace(
        '[[count]]',
        brandCount,
      )

      Brands.els.count.element.textContent = buttonText

      if (Brands.els?.['reset-categories']?.exists) {
        Brands.els['reset-categories'].element.setAttribute(
          'aria-disabled',
          String(!activeCategoryCount),
        )
      }
    }
  }

  handleResetClick (event) {
    if (event.target.getAttribute('aria-disabled') === 'true') {
      event.preventDefault()
      return
    }
    Brands.reset()
    Brands.resetCategories()
  }

  get activeTriggerEls () {
    return this.els.trigger.elements.filter(
      triggerEl => triggerEl.getAttribute('aria-checked') === 'true',
    )
  }
}

if (!customElements.get('brands-categories')) {
  customElements.define('brands-categories', BrandsCategories)
}

export class BrandsQuickView extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (!this.enabled) return

    this.mouseOverTimeout = null

    this.handleMouseMove = this.handleMouseMove.bind(this)
    this.listeners.add(document, 'mousemove', this.handleMouseMove)

    this.listeners.add(this, 'mouseover', this.handleMouseOver.bind(this))
  }

  handleMouseMove (event) {
    this.currentElement = event.target
  }

  handleMouseOver (event) {
    setTimeout(() => {
      if (
        this.currentElement?.closest(this.localName) ===
        event.target?.closest(this.localName)
      ) {
        this.render()
      }
    }, 400)
  }

  async render () {
    const targetEl = this.els.target.element

    if (!this.hasAttribute('aria-busy')) {
      this.setAttribute('aria-busy', 'true')
      const html = await fetchSingle('brand-quick-view', this.quickViewUrl)

      if (html?.length) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
        const sectionEl = getElement('.shopify-section', {
          context: parsedHTML,
        })
        targetEl.innerHTML = sectionEl.innerHTML
      }

      this.setAttribute('aria-busy', 'false')
    }
  }

  get quickViewUrl () {
    return this.getAttribute('url')
  }

  get enabled () {
    return (
      this.hasAttribute('url') && this.els?.target?.exists && !isTouchDevice()
    )
  }
}

if (!customElements.get('brands-quick-view')) {
  customElements.define('brands-quick-view', BrandsQuickView)
}

export class BrandsNavigation extends window.BAO.CustomElement({
  SuperClass: HTMLElement,
}) {
  static get requiredElements () {
    return ['link']
  }

  constructor () {
    super()
    this.isScrollingToSection = false
    this.isTouchDevice = isTouchDevice()
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.hash?.length) {
      this.disableNavigationHighlight = true
      this.applyPaginationOnPageLoad(this.hash)
    }

    this.setupIntersectionObserver()
  }

  setupListeners () {
    super.setupListeners()

    this.handlePaginationClick = this.handlePaginationClick.bind(this)
    this.handlePaginationHover = this.handlePaginationHover.bind(this)
    this.handleLink = this.handleLink.bind(this)

    this.els.pagination?.elements?.forEach(paginationEl => {
      this.listeners.add(paginationEl, 'click', this.handlePaginationClick)

      // Add hover preloading for non-touch devices
      if (!this.isTouchDevice) {
        this.listeners.add(
          paginationEl,
          'mouseenter',
          this.handlePaginationHover,
        )
      }
    })

    this.els.paginationNext?.elements?.forEach(paginationEl => {
      paginationEl.addEventListener('click', this.handlePaginationClick)

      if (!this.isTouchDevice) {
        this.listeners.add(
          paginationEl,
          'mouseenter',
          this.handlePaginationHover,
        )
      }
    })

    if (this.els?.link?.exists) {
      this.listeners.add(this, 'click', this.handleClick.bind(this))
    }

    document.querySelectorAll('.brd-Brand_Link').forEach(el => {
      this.listeners.add(el, 'click', this.handleLink)
    })

    document.querySelectorAll('.brd-Brand_Image').forEach(el => {
      this.listeners.add(el.querySelector('a'), 'click', this.handleLink)
    })
  }

  async handlePaginationHover (event) {
    const key = event.currentTarget.dataset.key
    // Only preload section content on hover (no UI updates)
    await this.renderPaginationSection(key)
  }

  async handlePaginationClick (event) {
    const key = event.currentTarget.dataset.key
    this.handlePaginationUIUpdate(key)

    const targetList = this.els.paginationBrands.elements.find(
      el => el.dataset.key === key,
    )

    const loadMore = this.els.paginationNext.elements.find(
      el => el.dataset.viewKey === key,
    )

    this.els.paginationNext.elements.forEach(el => {
      el.setAttribute('aria-hidden', 'true')
    })

    loadMore?.setAttribute('aria-hidden', 'false')

    // Section-render the appropriate brands section
    // On desktop this may already be loaded from hover, on mobile it loads now
    await this.renderPaginationSection(key, true)

    targetList?.querySelector('button').click()
  }

  async renderPaginationSection (key, loading = false) {
    // Only render for k-r, s-z, and 0-9 sections (a-j is server-side rendered)
    if (key === 'a-to-j') return

    const targetContainer = this.els.paginationContent.elements.find(
      el => el.dataset.key === key,
    )

    if (!targetContainer || targetContainer.hasAttribute('data-section-loaded')) { return }

    const sectionMap = {
      'k-to-r': 'template-brands-k-r',
      's-to-z': 'template-brands-s-z',
      '0-to-9': 'template-brands-0-9',
    }

    const sectionId = sectionMap[key]
    if (!sectionId) return

    Brands.els.container.element.setAttribute('aria-busy', loading)

    try {
      const html = await fetchSingle(sectionId, window.location.pathname)

      if (html?.length) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
        const sectionEl = getElement('.brd-Brands_PaginationContainer', {
          context: parsedHTML,
        })

        if (sectionEl) {
          targetContainer.innerHTML = sectionEl.innerHTML
          targetContainer.setAttribute('data-section-loaded', 'true')
        }
      }
    } catch (error) {
      console.error(`Failed to load section ${sectionId}:`, error)
    } finally {
      Brands.els.container.element.setAttribute('aria-busy', false)
    }
  }

  handleLink (el, e) {
    const letter = el.target
      .closest('.brd-Letter')
      .querySelector('[data-brands-el="heading"]')
      .dataset.letter.toLowerCase()

    const currentUrl = window.location.href

    // Push the new history state with the updated hash

    history.replaceState(null, '', `${currentUrl.split('#')[0]}${letter}`)
  }

  async applyPaginationOnPageLoad (hash) {
    const linkEl = this.els.link.elements.find(
      el => el.dataset.brandUrl === hash,
    )

    if (linkEl) {
      this.els.paginationBrands.elements.forEach(el =>
        el.setAttribute('aria-hidden', 'true'),
      )

      const parentPagination = linkEl.closest('.brd-Navigation_Items')
      const key = parentPagination.dataset.key

      // Section-render the appropriate brands section if needed
      await this.renderPaginationSection(key, true)

      this.handlePaginationUIUpdate(key)

      this.setCurrentLink(this.hash)

      // Small delay to ensure DOM is updated after section rendering
      setTimeout(() => {
        this.clickCurrentLinkEl()
      }, 100)
    }
  }

  handlePaginationUIUpdate (key) {
    const targetList = this.els.paginationBrands.elements.find(
      el => el.dataset.key === key,
    )
    const targetSection = this.els.paginationContent.elements.find(
      el => el.dataset.key === key,
    )

    this.els.pagination.elements.forEach(el =>
      el.classList.remove('brd-Brands_PaginationItem-active'),
    )

    const activeItem = this.els.pagination.elements.find(
      el => el.dataset.key === key,
    )

    activeItem.classList.add('brd-Brands_PaginationItem-active')

    this.els.paginationBrands.elements.forEach(el =>
      el.setAttribute('aria-hidden', 'true'),
    )
    targetList.setAttribute('aria-hidden', 'false')

    this.els.paginationContent.elements.forEach(el =>
      el.setAttribute('aria-hidden', 'true'),
    )
    targetSection.setAttribute('aria-hidden', 'false')
  }

  setupIntersectionObserver () {
    const isMobile = window.matchMedia('(max-width: 1024px)').matches
    const rootMargin = isMobile ? '0px 0px 0px 0px' : '0px 0px 0px 0px'

    const options = {
      root: null,
      rootMargin,
      threshold: [0, 0.5, 1],
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (this.isScrollingToSection) return
        const targetId = entry.target.dataset.letter.toLowerCase()

        const buttons = [
          ...document.querySelectorAll('[data-brands-navigation-el="link"]'),
        ]

        const button = buttons.find(
          button => button.dataset.brandUrl === targetId,
        )

        if (entry.isIntersecting) {
          const entryTop = entry.boundingClientRect.top

          if (entryTop <= 250) {
            buttons.forEach(button => {
              button?.setAttribute('aria-current', 'false')
            })
            button?.setAttribute('aria-current', 'true')
          }
        }
      })
    }, options)

    document
      .querySelectorAll('[data-brands-el="heading"]')
      .forEach(el => observer.observe(el))
  }

  handleClick (event) {
    const clickedLinkEl = event.target.closest(this.els?.link?.selector)
    const letter = clickedLinkEl?.dataset.brandLetter.toLowerCase()

    if (clickedLinkEl) {
      const section = document.querySelector(`#brand-${letter}`)

      if (!section) {
        console.warn(`Section #brand-${letter} not found in DOM`)
        // Still update the current link state even if section doesn't exist
        clickedLinkEl?.setAttribute('aria-current', 'true')
        if (letter) {
          history.pushState(null, '', `#brand-${letter}`)
        }
        return
      }

      const currentLinkEl = document.querySelector(
        '.brd-Navigation_Link[aria-current="true"]',
      )

      currentLinkEl
        ?.closest('.brd-Navigation_Items')
        ?.setAttribute('data-lock-intersection', 'true')

      if (currentLinkEl) {
        const isBefore =
          currentLinkEl.compareDocumentPosition(clickedLinkEl) &
          Node.DOCUMENT_POSITION_PRECEDING

        currentLinkEl.removeAttribute('aria-current')

        // Determine the scroll offset based on the scroll direction
        let offset = 0
        const isMobile = window.innerWidth < 1024

        if (isBefore) {
          if (document.body.classList.contains('lyt-Header-hidden') === true) {
            offset = isMobile ? 67 : 105 // finished
          } else {
            offset = isMobile ? 188 : 221 // finished
          }
        } else {
          if (document.body.classList.contains('lyt-Header-hidden') === false) {
            offset = isMobile ? 240 : 230 // finished
          } else {
            offset = isMobile ? 121 : 115 // finished
          }
        }

        // Get the top position of the section
        const sectionTop =
          section.getBoundingClientRect().top + window.pageYOffset

        // Scroll to the section with the appropriate offset

        this.isScrollingToSection = true
        window.scrollTo({
          top: sectionTop - offset,
          behavior: 'smooth',
        })
        setTimeout(() => {
          this.isScrollingToSection = false
        }, 1000)
      }
    }

    clickedLinkEl?.setAttribute('aria-current', 'true')

    if (letter) {
      history.pushState(null, '', `#brand-${letter}`)
    }
  }

  setCurrentLink (href) {
    this.els.link.elements.forEach(linkEl => {
      linkEl.setAttribute('aria-current', href === linkEl.dataset.brandUrl)
    })
  }

  clickCurrentLinkEl () {
    this.els.link.elements
      .find(linkEl => linkEl.getAttribute('aria-current') === 'true')
      ?.click()
  }

  get hash () {
    return window.location.hash
  }

  get rect () {
    return this.getBoundingClientRect()
  }
}

if (!customElements.get('brands-navigation')) {
  customElements.define('brands-navigation', BrandsNavigation, {
    extends: 'section',
  })
}

export class BrandsSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.searchTerm?.length && Brands.els?.['search-input']?.exists) {
      Brands.els['search-input'].element.value = this.searchTerm
      this.handleSearch(this.searchTerm)
    }
  }

  setupListeners () {
    super.setupListeners()

    if (Brands.els?.['search-input']?.exists) {
      this.onSearch = this.onSearch.bind(this)
      this.listeners.add(
        Brands.els['search-input'].element,
        'change',
        this.onSearch,
      )
      this.debouncedOnSearch = debounce(event => this.onSearch(event), 250)
      this.listeners.add(
        Brands.els['search-input'].element,
        'input',
        this.debouncedOnSearch,
      )
    }

    this.listeners.add(document, 'reset-search', this.handleReset.bind(this))
  }

  handleReset () {
    if (Brands.els['search-input']?.exists) {
      Brands.els['search-input'].element.value = ''
      Brands.els['search-input'].element.dispatchEvent(new Event('change'))
    }
  }

  /**
   * @param {Event} event - Event type should be 'input' or 'change'
   *
   * @returns {void}
   */
  onSearch (event) {
    event.preventDefault()

    Brands.reset()
    Brands.resetCategories()
    if (event?.isTrusted) {
      Brands.resetTabs()
    }

    this.handleSearch(event.target.value.trim())
  }

  /**
   * @param {string} searchTerm The search term entered by the user
   *
   * @returns {void}
   */
  handleSearch (searchTerm) {
    this.filterItemElements(searchTerm)
    this.hideSectionElements(searchTerm)
    this.toggleNoResultsMessage()

    if (searchTerm.length > 0) {
      /* Hide when search is conducted - required inside condition as this is triggered when search is reset */
      Brands.togglePromoElements(false)
    }
  }

  /**
   * Filter item elements and highlight the search term
   *
   * @returns {void}
   */
  filterItemElements (searchTerm) {
    Brands.els?.['search-item']?.elements?.forEach(itemEl => {
      const itemParentEl = itemEl.closest(Brands.els['brand-item']?.selector)
      itemParentEl?.setAttribute('aria-hidden', 'false')

      itemEl.innerHTML = itemEl.dataset?.brandsSearchValue

      const itemContainsSearchTerm = itemEl.dataset?.brandsSearchValueDowncase?.includes(
        searchTerm.toLowerCase(),
      )
      const isHidden = searchTerm.length > 0 && !itemContainsSearchTerm
      itemParentEl?.setAttribute('aria-hidden', String(isHidden))

      if (searchTerm.length > 0 && itemContainsSearchTerm) {
        const regEx = new RegExp(searchTerm, 'i')
        const replaceMask = `<span data-search-term>$&</span>`
        itemEl.innerHTML = itemEl.dataset?.brandsSearchValue?.replace(
          regEx,
          replaceMask,
        )
      }
    })
  }

  /**
   * Hide section elements containing no visible brands.
   *
   * @returns {void}
   */
  hideSectionElements (searchTerm) {
    if (searchTerm.length > 0) {
      Brands.hideEmptySections(Brands.els['body-desktop'].element)
    }

    this.visibleSectionEls?.pop()?.setAttribute('data-last', 'true')
  }

  /**
   * Toggle the no results message container.
   *
   * @returns {void}
   */
  toggleNoResultsMessage () {
    if (Brands.els?.['no-results']?.exists) {
      Brands.els['no-results'].element.setAttribute(
        'aria-hidden',
        String(!!this.visibleSectionEls?.length),
      )
    }
  }

  /**
   * @returns {string} The value of the query string parameter 's'
   */
  get searchTerm () {
    // eslint-disable-next-line compat/compat
    return new URL(window.location)?.searchParams?.get('s')
  }

  get visibleSectionEls () {
    return Brands.visibleSectionEls(Brands.els['body-desktop'].element)
  }
}

if (!customElements.get('brands-search')) {
  customElements.define('brands-search', BrandsSearch)
}
